import merge from 'deepmerge';
import CodeMirror from 'codemirror';
import Monkberry from 'monkberry';
import directives from 'monkberry-directives';
import 'monkberry-events';
import SchemaExecutableCodeTemplate from './schema-executable-fragment.monk';
import { THEMES } from '../utils';

export default class SchemaExecutableFragment extends SchemaExecutableCodeTemplate {
  static render(element, options = {}) {
    const instance = Monkberry.render(SchemaExecutableFragment, element, {
      directives: directives,
    });

    instance.initialized = false;
    instance.state = {
      theme: '',
      databaseSchema: '',
      code: '',
    };
    instance.codemirror = new CodeMirror();

    return instance;
  }

  update(state) {
    this.state = merge.all([this.state, state]);
    super.update(this.state);

    if (!this.initialized) {
      this.initializeCodeMirror(state);
      this.initialized = true;

      // Set initial value after initialization
      if (state.code !== undefined && state.code !== '') {
        this.codemirror.setValue(state.code);
        // Refresh to ensure proper display
        setTimeout(() => {
          if (this.codemirror) {
            this.codemirror.refresh();
          }
        }, 0);
      }
    } else {
      // Update value if already initialized
      if (state.code !== undefined && this.codemirror.getValue() !== state.code) {
        this.codemirror.setValue(state.code || '');
        this.codemirror.refresh();
      }
    }

    if (state.databaseSchema !== undefined) {
      this.state.databaseSchema = state.databaseSchema;
    }
  }

  initializeCodeMirror(options = {}) {
    const textarea = this.nodes[0].getElementsByTagName('textarea')[0];
    const codemirrorOptions = {
      readOnly: false,
      lineNumbers: true, // Always show line numbers
      mode: options.mode || 'text/x-kotlin',
      theme: options.theme,
      scrollbarStyle: options.scrollbarStyle || 'overlay',
      autoCloseBrackets: true,
      indentUnit: options.indent || 4,
      viewportMargin: Infinity,
      gutters: ['CodeMirror-linenumbers'], // Ensure line number gutter is added
      matchBrackets: true,
    };

    this.codemirror = CodeMirror.fromTextArea(textarea, codemirrorOptions);

    // Make sure it's not read-only by explicitly setting it
    this.codemirror.setOption('readOnly', false);

    // Listen for changes and update state
    this.codemirror.on('change', (cm) => {
      this.state.databaseSchema = cm.getValue();
      if (this.state.onChange) {
        this.state.onChange(cm.getValue());
      }
    });
  }

  getCode() {
    return this.codemirror.getValue();
  }

  destroy() {
    this.initialized = false;
    this.state = null;
    if (this.codemirror && this.codemirror.toTextArea) {
      this.codemirror.toTextArea();
    }
    // Only call off() if there are registered event listeners
    if (this.__events__ && Object.keys(this.__events__).length > 0) {
      this.off();
    }
    this.remove();
  }
}
